import axios from "axios";
import { currentDate, nextDate } from "./../utils/utils";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL_FOOTER = process.env.REACT_APP_BASE_URL_FOOTER;
const STATE = process.env.REACT_APP_STATE;
const TOWN = process.env.REACT_APP_TOWN;
const DATE = process.env.REACT_APP_DATE;
const TIME = process.env.REACT_APP_TIME_FASTING;
const FOOTER = process.env.REACT_APP_FOOTER;

export async function requestGetState(timeCode) {
  const request = await axios.get(`${BASE_URL}${STATE}`);
  const data = request.data;
  return data;
}

export async function requestGetDate(date) {
  const param = "?date=" + date;
  const request = await axios.get(`${BASE_URL}${DATE}${param}`);
  const data = request.data;
  return data;
}

export async function requestGetTown(idState) {
  const param = "?id_state=" + idState;
  const request = await axios.get(`${BASE_URL}${TOWN}${param}`);
  const data = request.data;
  return data;
}

export async function requestGetTimeFasting(timeCode) {
  const zone = "?zone=" + timeCode;
  const date1 = "&date1=" + currentDate();
  const date2 = "&date2=" + nextDate();
  const param = zone + "" + date1 + "" + date2;
  const request = await axios.get(`${BASE_URL}${TIME}${param}`);
  const data = request.data;
  return data;
}

export async function requestGetFooter() {
  const param = "?active=1";
  const request = await axios.get(`${BASE_URL_FOOTER}${FOOTER}${param}`);
  const data = request.data;
  return data;
}
